const publicSectorCode = (state = "", action) => {
    switch(action.type) {
        case 'publicSectorCode':
            return action.payload;
        default:
            return state;
    }
}

export default publicSectorCode;